module.exports = __webpack_public_path__ + "img/合并2.e891df96.svg";